import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const addBlogModalStyles: Record<string, SxProps<Theme>> = {
  paper: {
    borderRadius: "16px",
    overflow: "hidden",
    border: (t) => `1px solid ${alpha(t.palette.divider, 0.12)}`,
    boxShadow: (t) =>
      t.palette.mode === "dark"
        ? `0 24px 48px ${alpha("#000", 0.4)}`
        : `0 24px 48px ${alpha("#000", 0.12)}`,
  },
  header: {
    position: "relative",
    px: 3,
    py: 2.5,
    borderBottom: (t) => `1px solid ${alpha(t.palette.divider, 0.12)}`,
    background: (t) =>
      t.palette.mode === "dark"
        ? `linear-gradient(135deg, ${alpha("#f8481c", 0.12)} 0%, ${alpha(t.palette.background.paper, 0.5)} 50%, transparent 100%)`
        : `linear-gradient(135deg, ${alpha("#f8481c", 0.08)} 0%, ${alpha(t.palette.background.paper, 0.3)} 50%, transparent 100%)`,
  },
  closeButtonWrap: {
    position: "absolute",
    top: 12,
    right: 8,
  },
  headerTitle: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: (t) => t.palette.text.primary,
  },
  body: {
    px: 3,
    py: 2.5,
    bgcolor: (t) => t.palette.background.paper,
  },
  subtitle: {
    fontSize: "0.9375rem",
    color: (t) => t.palette.text.secondary,
    mb: 2.5,
  },
  optionCard: {
    p: 2,
    borderRadius: "12px",
    border: (t) => `2px solid ${alpha(t.palette.divider, 0.2)}`,
    bgcolor: (t) =>
      t.palette.mode === "dark"
        ? alpha(t.palette.background.paper, 0.6)
        : alpha(t.palette.background.paper, 1),
    cursor: "pointer",
    transition: "all 0.25s ease",
    "&:hover": {
      borderColor: (t) => alpha("#f8481c", 0.5),
      bgcolor: (t) => alpha("#f8481c", 0.06),
    },
    "&.selected": {
      borderColor: "#f8481c",
      bgcolor: (t) => alpha("#f8481c", 0.1),
      boxShadow: (t) =>
        `0 0 0 1px ${alpha("#f8481c", 0.2)}, 0 4px 12px ${alpha("#f8481c", 0.08)}`,
    },
  },
  optionTitle: {
    fontSize: "0.9375rem",
    fontWeight: 600,
    color: (t) => t.palette.text.primary,
    mb: 0.5,
  },
  optionDesc: {
    fontSize: "0.8125rem",
    color: (t) => t.palette.text.secondary,
    lineHeight: 1.4,
  },
  formControl: {
    mt: 2.5,
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      bgcolor: (t) =>
        t.palette.mode === "dark"
          ? alpha(t.palette.background.paper, 0.4)
          : t.palette.background.paper,
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: (t) => alpha("#f8481c", 0.4),
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#f8481c",
        borderWidth: "1px",
      },
    },
  },
  textField: {
    mt: 2,
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      bgcolor: (t) =>
        t.palette.mode === "dark"
          ? alpha(t.palette.background.paper, 0.4)
          : t.palette.background.paper,
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: (t) => alpha("#f8481c", 0.4),
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#f8481c",
        borderWidth: "1px",
      },
    },
  },
  footer: {
    px: 3,
    py: 2,
    borderTop: (t) => `1px solid ${alpha(t.palette.divider, 0.12)}`,
    bgcolor: (t) =>
      t.palette.mode === "dark"
        ? alpha(t.palette.background.paper, 0.4)
        : alpha(t.palette.grey[50], 0.8),
    gap: 1.5,
  },
  cancelButton: {
    textTransform: "none",
    fontWeight: 600,
    color: (t) => t.palette.text.secondary,
    "&:hover": {
      bgcolor: (t) => alpha(t.palette.text.secondary, 0.08),
    },
  },
  generateButton: {
    minHeight: 40,
    px: 2.5,
    py: 1.25,
    fontSize: "0.9375rem",
    fontWeight: 600,
    borderRadius: "10px",
    textTransform: "none",
    bgcolor: "#f8481c",
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      bgcolor: "#e03d18",
      color: "#fff",
      boxShadow: "none",
    },
    "&:disabled": {
      bgcolor: (t) => alpha("#f8481c", 0.4),
      color: "#fff",
    },
  },
  closeButton: {
    color: (t) => t.palette.text.secondary,
    "&:hover": {
      bgcolor: (t) => alpha(t.palette.text.secondary, 0.08),
      color: (t) => t.palette.text.primary,
    },
  },
};

export default addBlogModalStyles;
